import Vue from 'vue'
import VueGamepad from 'vue-gamepad'
import VueShortkey from 'vue-shortkey'

import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.use(VueGamepad)
Vue.use(VueShortkey, {
  prevent: [
    'input',
    'textarea'
  ]
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
